export default __webpack_public_path__ + "static/media/selection.f5cb5ae4.svg";